import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n"; // Initialize i18n before app renders
import { syncDbaThemeFromEntry } from "./lib/dbaTheme";

async function bootstrap() {
  // NP-505: set the DBA scheme before the first render rather than in DbaThemeSync's
  // effect, so the first frame of app content is already in the branch's colours.
  syncDbaThemeFromEntry();

  // Start MSW ONLY on localhost — never on deployed environments
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocalhost && (import.meta.env.DEV || import.meta.env.VITE_API_MODE === 'mock')) {
    const { initMocks } = await import('./mocks');
    await initMocks();
  }

  createRoot(document.getElementById("root")!).render(<App />);
}

bootstrap();
